// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.keycloak-logo__image {
  margin: 0 auto;
}
.keycloak-logo__image:visited,
.keycloak-logo__image:link,
.keycloak-logo__image:active,
.keycloak-logo__image:focus,
.keycloak-logo__image:hover,
.keycloak-logo__image:focus-within,
.keycloak-logo__image:focus-visible {
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/keycloak/ui/KeycloakLogo.less"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ;AAEI;;;;;;;EACE,cAAA;AAMN","sourcesContent":[".keycloak-logo {\n  &__image {\n    margin: 0 auto;\n\n    &:visited, &:link, &:active, &:focus, &:hover, &:focus-within, &:focus-visible {\n      color: inherit;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
